export const PASSIVE_COMPLETION_DIVISORS = [1, 10, 100, 1000];

const normalizeDivisor = (value) => {
  const numericValue = Number(value);
  return PASSIVE_COMPLETION_DIVISORS.includes(numericValue) ? numericValue : 1;
};

export const createPassiveCompletionConfig = (config) => ({
  messageEnabled: config?.messageEnabled ?? true,
  signalEnabled: config?.signalEnabled ?? false,
  divisors: {
    cuttingLength: normalizeDivisor(config?.divisors?.cuttingLength),
    materialSize1: normalizeDivisor(config?.divisors?.materialSize1),
    materialSize2: normalizeDivisor(config?.divisors?.materialSize2),
    remainingMaterial: normalizeDivisor(config?.divisors?.remainingMaterial),
  },
});

export const completionModeFromConfig = (config) => {
  const normalized = createPassiveCompletionConfig(config);
  if (normalized.signalEnabled) return 'signal';
  if (normalized.messageEnabled) return 'message';
  return 'off';
};

export const buildPassiveCompletionConfig = ({ mode, divisors }) => ({
  messageEnabled: mode === 'message',
  signalEnabled: mode === 'signal',
  divisors: createPassiveCompletionConfig({ divisors }).divisors,
});
